export function productivityFromDeviceEvents(moment, deviceEvents) {
  let runningEventSeconds = 0
  let holdEventSeconds = 0
  let idleEventSeconds = 0
  let qualityEventSeconds = 0
  let availableSeconds = 0
  let totalSeconds = 0
  let performanceSeconds = 0

  deviceEvents.forEach(function(deviceEvent) {
    let duration = moment.duration(
      moment(deviceEvent.end).diff(moment(deviceEvent.start, 'YYYY/MM/DD HH:mm'))
    )

    if (deviceEvent.shiftPattern.workingShift && deviceEvent.activity.working) {
      totalSeconds = totalSeconds + duration.asSeconds()
    }

    // Availiability
    if (
      deviceEvent.activity.available &&
      deviceEvent.shiftPattern.workingShift &&
      deviceEvent.activity.working
    ) {
      availableSeconds = availableSeconds + duration.asSeconds()
    }

    // Performance
    if (
      deviceEvent.activity.available &&
      deviceEvent.status.type === 1 &&
      deviceEvent.shiftPattern.workingShift &&
      deviceEvent.activity.working
    ) {
      performanceSeconds = performanceSeconds + duration.asSeconds()
    }

    // Quality
    if (deviceEvent.activity.quality) {
      qualityEventSeconds = qualityEventSeconds + duration.asSeconds()
    }

    if (deviceEvent.status.type === 1) {
      runningEventSeconds = runningEventSeconds + duration.asSeconds()
    } else if (deviceEvent.status.type === 0 || deviceEvent.status.type === 4) {
      idleEventSeconds = idleEventSeconds + duration.asSeconds()
    } else {
      holdEventSeconds = holdEventSeconds + duration.asSeconds()
    }
  })

  let availability = availableSeconds / totalSeconds

  let performance = performanceSeconds / availableSeconds

  let quality = (availableSeconds - qualityEventSeconds) / availableSeconds

  let productivity = {
    productivityValue: Math.round(availability * performance * quality * 100),
    availability: Math.round(availability * 100),
    performance: Math.round(performance * 100),
    quality: Math.round(quality * 100),
    runningEventSeconds: runningEventSeconds / 60,
    holdEventSeconds: holdEventSeconds / 60,
    idleEventSeconds: idleEventSeconds / 60,
  }

  return productivity
}
